import { asBondPriceNominal } from "@goodfill/domain-properties";
import { BondPriceComponent } from "@goodfill/domain-properties-components";
import { DecimalRangeColumnDefinition, decimalRangeFilter } from "../generic/DecimalRangeColumnDefinition";
import { DecimalRange } from "../../../filters/DecimalRangeFilter";

export const LOADED_BOND_PRICE_CRITERIA_KEY = "postFeePrice";

type CriteriaValue = DecimalRange;
type Criteria = { [LOADED_BOND_PRICE_CRITERIA_KEY]: CriteriaValue };
type FilterChangeFunction = (key: typeof LOADED_BOND_PRICE_CRITERIA_KEY, value: CriteriaValue) => void;

export const postFeePriceFilter = <TItemKey extends string>(key: TItemKey) =>
  decimalRangeFilter(LOADED_BOND_PRICE_CRITERIA_KEY, key);

export const PostFeePriceColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: Criteria,
  onFilterChange: FilterChangeFunction,
) =>
  DecimalRangeColumnDefinition({
    name: "Post-Fee Order Price",
    itemKey,
    criteriaKey: LOADED_BOND_PRICE_CRITERIA_KEY,
    criteria: {
      ...criteria,
      postFeePrice: [criteria.postFeePrice[0]?.mul(100) ?? null, criteria.postFeePrice[1]?.mul(100) ?? null],
    },
    onFilterChange: (key, value) => onFilterChange(key, [value[0]?.div(100) ?? null, value[1]?.div(100) ?? null]),
    itemRenderer: (row) => <BondPriceComponent value={asBondPriceNominal(row[itemKey])} />,
  });
